import { base64ToArray, decryptWithRsaBlockCipher, encryptionKeyPairFromArray, encryptWithAes, verifyPublicPrivateKeyPair, } from '@lucidlink/ts-crypto/crypto';
import { verifyWorkspaceCryptoTuple } from '../crypto/crypto-utils';
import { InvitationManagementError } from './invitation-manager-errors';
export const prepareInvitationKeyListForMigration = async (response, adminCrypto, workspaceId) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const ssoCrypto = await adminCrypto.getSsoCrypto();
    const ssoKey = await ssoCrypto.verifyAndGetSsoSecretKey();
    const invitationKeysPromises = response.map(async ({ id, ePrivateKeyByAdminKey, publicKey, sInvitationByAdminKey, ePrivateKeyBySsoSecret, }) => {
        return prepareAnInvitationRecordForSso(adminKeys.encryptPair.privateKey, adminKeys.signPair.publicKey, ssoKey, workspaceId, {
            id,
            ePrivateKeyByAdminKey,
            publicKey,
            sInvitationByAdminKey,
            ePrivateKeyBySsoSecret,
        });
    });
    const updateBatch = [];
    const promiseSettledResult = await Promise.allSettled(invitationKeysPromises);
    promiseSettledResult.forEach((res) => {
        if (res.status === 'rejected') {
            throw res.reason;
        }
        updateBatch.push(res.value);
    });
    return updateBatch;
};
const prepareAnInvitationRecordForSso = async (adminPrivateKey, adminSignPublicKey, ssoKey, workspaceId, { id, ePrivateKeyByAdminKey, publicKey, sInvitationByAdminKey, ePrivateKeyBySsoSecret, }) => {
    if (ePrivateKeyBySsoSecret) {
        throw new InvitationManagementError(`Invitation with id=${id} already has private key encrypted by sso secret`);
    }
    const invitationPrivateKeyArr = await decryptWithRsaBlockCipher(ePrivateKeyByAdminKey, adminPrivateKey);
    const invitationPublicKeyArray = base64ToArray(publicKey);
    const isSignatureVerified = await verifyWorkspaceCryptoTuple({ id, workspaceId, publicKey: invitationPublicKeyArray }, base64ToArray(sInvitationByAdminKey), adminSignPublicKey);
    if (!isSignatureVerified) {
        throw new InvitationManagementError(`Invitation with id=${id} has invalid signature ${sInvitationByAdminKey}`);
    }
    const invitationPair = await encryptionKeyPairFromArray(invitationPublicKeyArray, invitationPrivateKeyArr);
    try {
        await verifyPublicPrivateKeyPair(invitationPair);
    }
    catch {
        throw new InvitationManagementError(`Invitation with id=${id} has invalid keys ${sInvitationByAdminKey}`);
    }
    return {
        id,
        ePrivateKeyBySsoSecret: await encryptWithAes(invitationPrivateKeyArr, ssoKey),
    };
};
